import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import DeviceService from "../DevicesService";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

type ProjectInfoProps = {
  projectName: string;
  did: string;
  userId: number;
  onNext: () => void;
};
function ProjectInfo(props: ProjectInfoProps) {
  const { t } = useTranslation();

  const [projectName, setProjectName] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const [client, setClient] = useState<string>("");
  const [company, setCompany] = useState<string>("");
  const [location, setLocation] = useState<string>("");
  const [observer, setObserver] = useState<string>("");
  const [norm, setNorm] = useState<any>({});
  const [errors, setErrors] = useState<any>([]);
  const [btnDisable, setBtnDisable] = useState<boolean>(false);

  const deviceService = new DeviceService();
  const norms = [
    { name: "Custom", value: "Custom" },
    { name: "DIN 4150-3 (1-315 Hz)", value: "DIN 4150-3 (1-315 Hz)" },
    { name: "DIN 4150-3 (1-80 Hz)", value: "DIN 4150-3 (1-80 Hz)" },
    { name: "DIN 4150-2 (1-80 Hz)", value: "DIN 4150-2 (1-80 Hz)" },
  ];

  const onNormChange = (e: { value: any }) => {
    setNorm(e.value);
  };

  const validate = () => {
    let error: any = {};

    if (projectName === "") {
      error["projectName"] = t('projectName_error');
      setErrors(error);
    }

    if (norm === "" || norm === undefined) {
      error["norm"] = t('norm_error');
      setErrors(error);
    }
    if (Object.keys(error).length !== 0) {
      return false;
    }

    return true;
  };
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);
    setBtnDisable(true);
    setProjectName(props.projectName);
    deviceService
      .getDeviceDetails(props.userId, props.projectName, props.did)
      .then((response) => {
        setComment(response["final_json"]["json"]["FILE_NOTE"]);
        setClient(response["final_json"]["json"]["FILE_CLIENT"]);
        setCompany(response["final_json"]["json"]["FILE_COMPANY"]);
        setLocation(response["final_json"]["json"]["FILE_LOCATION"]);
        setObserver(response["final_json"]["json"]["FILE_OBSERVER"]);
        setNorm(response["final_json"]["json"]["MEASUREMENT_STANDARD"]);
        let deviceMessaging : any ={
          1: {
            checkedValue: +response["final_json"]["json"]["SMS_USER0_FLAGS"],
            inputValue: response["final_json"]["json"]["SMS_USER0_NUMBER"],
            trigger: +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 15,
            warning: +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 15 ,
            alarm: +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 4 || +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 15,
            system: +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 8 || +response["final_json"]["json"]["SMS_USER0_FLAGS"] === 15
          },
          2:{
            checkedValue: +response["final_json"]["json"]["SMS_USER1_FLAGS"],
            inputValue: response["final_json"]["json"]["SMS_USER1_NUMBER"],
            trigger: +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 15,
            warning: +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 15 ,
            alarm: +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 4 || +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 15,
            system: +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 8 || +response["final_json"]["json"]["SMS_USER1_FLAGS"] === 15
          },
          3:{
            checkedValue: +response["final_json"]["json"]["SMS_USER2_FLAGS"],
            inputValue: response["final_json"]["json"]["SMS_USER2_NUMBER"],
            trigger: +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 15,
            warning: +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 15 ,
            alarm: +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 4 || +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 15,
            system: +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 8 || +response["final_json"]["json"]["SMS_USER2_FLAGS"] === 15
          },
          4:{
            checkedValue: +response["final_json"]["json"]["SMS_USER3_FLAGS"],
            inputValue: response["final_json"]["json"]["SMS_USER3_NUMBER"],
            trigger: +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 15,
            warning: +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 15 ,
            alarm: +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 4 || +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 15,
            system: +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 8 || +response["final_json"]["json"]["SMS_USER3_FLAGS"] === 15
          },
          5:{
            checkedValue: +response["final_json"]["json"]["SMS_USER4_FLAGS"],
            inputValue: response["final_json"]["json"]["SMS_USER4_NUMBER"],
            trigger: +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 15,
            warning: +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 15 ,
            alarm: +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 4 || +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 15,
            system: +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 8 || +response["final_json"]["json"]["SMS_USER4_FLAGS"] === 15
          },
          6:{
            checkedValue: +response["final_json"]["json"]["SMS_USER5_FLAGS"],
            inputValue: response["final_json"]["json"]["SMS_USER5_NUMBER"],
            trigger: +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 15,
            warning: +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 15 ,
            alarm: +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 4 || +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 6 || +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 7 || +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 15,
            system: +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 8 || +response["final_json"]["json"]["SMS_USER5_FLAGS"] === 15
          },
          7:{
            inputValue: response["final_json"]["json"]["SMS_WARN_LEVEL"],
          },
          8:{
            inputValue: response["final_json"]["json"]["SMS_ALARM_LEVEL"],
          },
          9:{
            inputValue: response["final_json"]["json"]["SMS_SILENCE_TIME"],
          },
        }
        localStorage.setItem(
            "deviceMessaging",
            JSON.stringify(deviceMessaging)
        );
        setBtnDisable(false);
      });
  }, [i18n.language]);
  return (
    <>
      <Card
        title={t("project_information")}
        className="InputForms_container mt-4"
      >
        <div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("project_name")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                  disabled
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["projectName"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("comment")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["comment"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("client")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={client}
                  onChange={(e) => setClient(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["client"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("company")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["company"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("location")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["location"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("observer")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={observer}
                  onChange={(e) => setObserver(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["observer"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("norm")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <Dropdown
                  className="p-inputtext-sm  mb-0 ml-5"
                  value={norm}
                  options={norms}
                  onChange={onNormChange}
                  optionLabel="name"
                  placeholder={t('select_norm')}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["norm"]}</p></div>
          </div>
          <div className="flex flex-wrap align-items-center justify-content-center lg:justify-content-between">
            <p className="text-danger text-underline"></p>
            <p className="text-danger"></p>
            <div>
              <Button
                icon="pi pi-angle-right"
                label={t("next")}
                className="p-button-outlined p-button-secondary"
                disabled={btnDisable}
                onClick={() => {
                  setErrors([]);
                  if (validate()) {
                    let projectInfo: any = {
                      projectName: projectName,
                      comment: comment,
                      client: client,
                      company: company,
                      location: location,
                      observer: observer,
                      norm: norm,
                    };
                    localStorage.setItem(
                      "projectInfo",
                      JSON.stringify(projectInfo)
                    );
                    props.onNext();
                  }
                }}
              />
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}
export default ProjectInfo;
